import { render, staticRenderFns } from "./KaoguanjianduLayout.vue?vue&type=template&id=0475a31d&scoped=true&"
import script from "./KaoguanjianduLayout.vue?vue&type=script&lang=js&"
export * from "./KaoguanjianduLayout.vue?vue&type=script&lang=js&"
import style0 from "./KaoguanjianduLayout.vue?vue&type=style&index=0&id=0475a31d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475a31d",
  null
  
)

export default component.exports